import { ICommand } from 'core-ts-types';
import { IStaffDrivenData, StaffTodoListQuery } from 'data-ng-staff-todos';
import * as _4 from 'lodash4';
import { TypeUtility } from 'utility-ts-type';
import { PathTaskFormatter } from '../../data/functions/path_task_formatter_fn';

interface IStaffTodoDetailsModel {
  title: string;
  sentBy: string;
  completedBy: string;
  isCompleted: boolean;
  isOverdue: boolean;
  subtitle: string;
  showDescription: boolean;
  description: string;
}

export class StaffTodoDetailsController {
  private staffTodoId: any;
  private model: IStaffTodoDetailsModel;
  private staffTodoData: IStaffDrivenData;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngStaffTodoListQuery: StaffTodoListQuery,
    private ngTypeUtility: typeof TypeUtility,
    private log: any,
    private ngPathTaskFormatter: PathTaskFormatter,
    private completeStaffTodoCommand: ICommand,
    private loadStaffTodoItemCommand: ICommand
  ) {
    if (_4.isEmpty(ngStaffTodoListQuery.result)) {
      this.loadStaffTodoItemCommand(this.$stateParams.staffTodoID).then((response: any) => {
        this.staffTodoData = response;
        this.loadModel();
      });
    } else {
      this.staffTodoData = _4.head(
        _4.filter(ngStaffTodoListQuery.result, (todo: IStaffDrivenData) => {
          return todo.id == this.$stateParams.staffTodoID;
        })
      );
      this.loadModel();
    }
  }

  updateStaffTodoStatus(): void {
    this.completeStaffTodoCommand(this.$stateParams.staffTodoID, this.model.isCompleted).then(
      (response: { reminder: any }) => {
        this.staffTodoData = response.reminder;
        this.loadModel();
      }
    );
  }

  isOverdue() {
    return moment(_4.get(this.staffTodoData, 'due_date', '')).isBefore(moment(), 'day');
  }

  getDateLabel() {
    return this.ngPathTaskFormatter.getStaffTodoText(this.staffTodoData, this.isOverdue(), false);
  }

  loadModel() {
    if (this.staffTodoData) {
      this.model = {
        title: _4.get(this.staffTodoData, 'name'),
        sentBy: _4.get(this.staffTodoData, 'created_by_name'),
        completedBy: _4.get(this.staffTodoData, 'cleared_by_name'),
        isCompleted: !_4.isEmpty(_4.get(this.staffTodoData, 'cleared_date')),
        isOverdue: this.isOverdue(),
        subtitle: this.getDateLabel(),
        showDescription: !_4.isEmpty(_4.get(this.staffTodoData, 'description')),
        description: _4.get(this.staffTodoData, 'description')
      };
    } else {
      this.log.issue("The to-do from staff you're looking for does not exist.");
    }
  }
}

export class StaffTodoDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/staff_todo_details/staff_todo_details.html';
  public controller: any = StaffTodoDetailsController;
  public bindings: any = {
    staffTodoId: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/staff_todo_details/staff_todo_details_controller.ts